var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnauHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16176",
    "data-name": "Group 16176",
    transform: "translate(-975 -1656)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(975 1656)",
    fill: "#0464ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    transform: "translate(966.561 1676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16152",
    "data-name": "Group 16152",
    transform: "translate(30.849 1.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16151",
    "data-name": "Group 16151",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47779",
    "data-name": "Path 47779",
    d: "M63.359,33.38,50.1,20.125a3.515,3.515,0,0,0-5.4,4.452l-.018.092a24.524,24.524,0,0,1-6.728,12.572l-6.08,6.08a3.513,3.513,0,0,0,0,4.97L35.193,51.6a3.513,3.513,0,0,0,4.97,0l.828-.828,5.8,5.8a3.515,3.515,0,0,0,4.97-4.97L49.276,49.12l.828-.828a3.513,3.513,0,0,0,0-4.97l-.563-.563A24.527,24.527,0,0,1,58.815,38.8l.093-.019a3.519,3.519,0,0,0,4.451-.428h0A3.519,3.519,0,0,0,63.359,33.38ZM38.507,49.948a1.171,1.171,0,0,1-1.657,0l-3.314-3.314a1.171,1.171,0,0,1,0-1.657l5.8-5.8,4.97,4.97Zm11.6,3.314a1.172,1.172,0,0,1-1.657,1.657l-5.8-5.8,1.657-1.657Zm-4.142-7.456c.352-.352.879-.892,1.711-1.6l.774.774a1.171,1.171,0,0,1,0,1.657l-.828.828Zm.05-3.264-5.07-5.07a26.829,26.829,0,0,0,5.7-10.864L56.877,36.838A26.827,26.827,0,0,0,46.012,42.542ZM61.7,36.694a1.171,1.171,0,0,1-1.657,0L46.791,23.439a1.172,1.172,0,0,1,1.657-1.657L61.7,35.037A1.173,1.173,0,0,1,61.7,36.694Z",
    transform: "translate(-30.849 -19.098)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16154",
    "data-name": "Group 16154",
    transform: "translate(36.507 25.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16153",
    "data-name": "Group 16153",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47780",
    "data-name": "Path 47780",
    d: "M106.923,325.105a1.172,1.172,0,0,0-1.657,0l-1.657,1.657a1.172,1.172,0,0,0,1.657,1.657l1.657-1.657A1.172,1.172,0,0,0,106.923,325.105Z",
    transform: "translate(-103.266 -324.762)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16156",
    "data-name": "Group 16156",
    transform: "translate(54.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16155",
    "data-name": "Group 16155",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47781",
    "data-name": "Path 47781",
    d: "M332.366,0a1.172,1.172,0,0,0-1.172,1.172V3.515a1.172,1.172,0,0,0,2.343,0V1.172A1.172,1.172,0,0,0,332.366,0Z",
    transform: "translate(-331.194)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16158",
    "data-name": "Group 16158",
    transform: "translate(61.343 9.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16157",
    "data-name": "Group 16157",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47782",
    "data-name": "Path 47782",
    d: "M424.684,119.966h-2.343a1.172,1.172,0,1,0,0,2.343h2.343a1.172,1.172,0,1,0,0-2.343Z",
    transform: "translate(-421.169 -119.966)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16160",
    "data-name": "Group 16160",
    transform: "translate(59 2.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16159",
    "data-name": "Group 16159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47783",
    "data-name": "Path 47783",
    d: "M395.521,30.334a1.171,1.171,0,0,0-1.657,0l-2.343,2.343a1.172,1.172,0,1,0,1.657,1.657l2.343-2.343A1.172,1.172,0,0,0,395.521,30.334Z",
    transform: "translate(-391.178 -29.991)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnauHome);
export default __webpack_public_path__ + "static/media/annauHome.2834b5b19045c031e0928dce27a212d9.svg";
export { ForwardRef as ReactComponent };